export default {
  Nav: {
    Home: '官网首页',
    About: '关于我们',
    Game: '游戏产品',
    Joinus: '加入我们',
    contactUs: '联系我们',
    secret: '隐私协议',
    terms: '服务条款',
    safe: '账户安全',
  },
  Footer: {
    cont: "Copyright {'@'} 2023 All Right Reserved 弘娱網絡科技有限公司 版权所有",
  },
  commencont: {
    Coming: '敬请期待',
  },
  homecont: {},
  contactus: {
    address: '中国香港新界屯门天后路1号彩星大厦1期2楼',
    title: '弘娱網絡科技有限公司',
  },
  Aboutus: {
    about1:
      '弘娱網絡公司成立于2023年、 是一家专注于互动娱乐领域的新型互联网文化公司。公司致力于原创精品游戏的创作与研发，并将在游戏等各个不同的文化娱乐领域持续深耕，立足全球发展、创造全新的互动娱乐体验。',
    // about2: '公司拥有业界顶级的研发、营运团队、雄厚的技术实力，公司业务涵盖游戏，动漫等，公司当前多款精品游戏同步研发中，我们将凭借着优秀的团队服务全球用户。',
    // about3: '未来，悠樂游戏将继续开发和发布精品游戏产品，超越用户的期望，为全球各地的玩家带来有趣、令人兴奋的娱乐体验和优质服务。',
  },
  title: {
    title: '弘娱網絡 - 全球手机游戏发行与研发商',
    Keywords:
      '弘娱網絡,手机游戏,網絡游戏,mobile game,安卓游戏,苹果游戏,ios游戏,android游戏,网络游戏,发行商,海外游戏,香港游戏,谷歌商店,苹果商店,下载,安装,免费游戏.',
    Description: '一家手机游戏研发与发行商。',
  },
  Secret: {
    src: '/static/policy.html',
  },
  Terms: {
    src: '/static/terms.html',
  },
  Account: {
    line1:
      '如果您要删除游戏相关的账户信息，请填写以下信息（账户一旦删除无法恢复）',
    line2:
      '提示：如果您是谷歌账号或Facebook账号登录，则需去游戏内悬浮窗创建账号，再填写账号密码',
    line3: "发送uid/account/password信息至客服邮箱xinshengcrm{'@'}gmail.com",
    form1: '请输入uid',
    form2: '请输入账户',
    form3: '请输入密码',
    btn1: '删除账号',
    btn2: '删除数据',
    btn3: '取消',
    btn4: '确认',
  },
  Booking: {
    success: '预约成功',
  },
  Game: {
    list: [
      {
        name: 'DeadFront',
        introduction:
          'DeadFront是一款独特的放置卡牌角色扮演游戏，将英雄收集、SLG基地建设、塔防与派系战争融为一体，带来深度策略体验。招募传奇英雄，加固避难所，率领联盟征服废土。进度永不停歇——即使你离线，你的幸存者们也会持续战斗并搜刮战利品。',
        facebook: 'https://www.facebook.com/profile.php?id=61589437860611',
        discord: 'https://discord.gg/5VdNtF2aBz',
        ios: 'https://apps.apple.com/us/app/deadfront-zombie-survival-rpg/id6781503453',
        android:
          'https://play.google.com/store/apps/details?id=com.hongyu.deadfront',
      },
      {
        name: 'Emberbone: Blood and Ash→2.5D',
        introduction:
          'Emberbone: Blood and Ash是一款大型3D MMORPG，背景设定于黑暗奇幻开放世界，白骨铺满战场，火焰已化为灰烬。探索无缝边疆，召唤远古之灵，铸就你的传说，并在这款史诗级在线RPG中为沙巴克而战。',
        facebook: 'https://www.facebook.com/profile.php?id=61591302717172',
        discord: 'https://discord.gg/XCqbcrU5TX',
        ios: '',
        android: '',
      },
    ],
  },
}
